const accessToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2Mzg4YzFjNmRmMjM3MTA4ZDliZjU0MGMiLCJpc0FkbWluIjp0cnVlLCJpYXQiOjE2ODY2OTMwMzksImV4cCI6MTY5MTg3NzAzOX0.3c34RjMxkl0sn6giTDCvdmok1nlsg5Xcsa6OS-4RvBs"
export default accessToken
